import React from 'react';
import { FiArrowLeft } from 'react-icons/fi';

const TermsAndConditions = () => {
  return (
    <div className="sm:min-h-full sm:pb-10 lg:pb-10 md:pb-10 xl:pb-10 xs:pt-4 sm:pt-4 xs:pb-10 xs:min-h-full min-h-screen flex flex-col">
      <div className='w-full py-10 xl:px-[10%] lg:px-[8%] xs:px-[5%] md:px-[6%] sm:px-[5%] px-6 pt-10'>
         <a href="/"
                    
                    className="text-black hover:text-gray-600 transition"
                  >
                    <FiArrowLeft size={24} />
                  </a>
        <h1 className="text-[40px] xs:text-[16px] px-14 lg:px-[5%] flex justify-center xs:px-4 font-semibold font-inter text-black">Terms & Conditions</h1>

        <p className="mb-4 text-[20px] md:sm:text-[16px] xs:text-[15px]">
          <strong>Introduction</strong><br />
          Welcome to Drunkmates. By downloading or using our app, these terms will automatically apply to you – you should make sure therefore that you read them carefully before using the app.
        </p>

        <h2 className="text-[25px] font-semibold mt-6 mb-2">1. Use of the App</h2>
        <p className="mb-4 text-[20px] md:sm:text-[16px] xs:text-[15px]">
          You agree to use the app only for lawful purposes and in a way that does not infringe the rights of others. You must not misuse or interfere with the app or try to access it using a method other than the interface and the instructions that we provide.
        </p>

        <h2 className="text-[25px] font-semibold mt-6 mb-2">2. Intellectual Property</h2>
        <p className="mb-4 text-[20px] md:sm:text-[16px] xs:text-[15px]">
          All intellectual property rights in the app and its content are owned by Drunkmates LLC. You are not permitted to use or reproduce any part of the app or its content without our express written permission.
        </p>

        <h2 className="text-[25px] font-semibold mt-6 mb-2">3. Restrictions</h2>
        <ul className="list-disc list-inside mb-4 text-[20px] md:sm:text-[16px] xs:text-[15px]">
          <li>You may not use the app for any illegal activity.</li>
          <li>You may not copy, modify, or reverse engineer the app.</li>
          <li>You may not use the app in a way that causes damage to the app or impairs the availability of access.</li>
        </ul>

        <h2 className="text-[25px] font-semibold mt-6 mb-2">4. Limitation of Liability</h2>
        <p className="mb-4 text-[20px] md:sm:text-[16px] xs:text-[15px]">
          Drunkmates LLC is not liable for any indirect, incidental, special, consequential or punitive damages arising from your use of or inability to use the app.
        </p>

        <h2 className="text-[25px] font-semibold mt-6 mb-2">5. Termination</h2>
        <p className="mb-4 text-[20px] md:sm:text-[16px] xs:text-[15px]">
          We reserve the right to terminate or suspend your access to the app immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
        </p>

        <h2 className="text-[25px] font-semibold mt-6 mb-2">6. Governing Law</h2>
        <p className="mb-4 text-[20px] md:sm:text-[16px] xs:text-[15px]">
          These Terms shall be governed and construed in accordance with the laws of the jurisdiction in which Drunkmates LLC operates, without regard to its conflict of law provisions.
        </p>

        <h2 className="text-[25px] font-semibold mt-6 mb-2">7. Changes to These Terms</h2>
        <p className="mb-4 text-[20px] md:sm:text-[16px] xs:text-[15px]">
          We may update our Terms and Conditions from time to time. You are advised to review this page periodically for any changes. Continued use of the app after changes means you accept the new terms.
        </p>

        <h2 className="text-[25px] font-semibold mt-6 mb-2">8. Contact Us</h2>
        <p className="mb-4 text-[20px] md:sm:text-[16px] xs:text-[15px]">
          If you have any questions about our Terms and Conditions, please contact us at:<br />
          <strong>Drunkmates LLC</strong><br />
          Christophar Devis<br />
          <a href="mailto:chris@drunkmates.com" className="text-blue-600 underline">chris@drunkmates.com</a>
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditions;
